
<!--
  功能：产品项目筛选
-->
<template>
<div class="screeningItem">
  <el-form ref="screeningItemFormRef" :model="screeningItemForm" :rules="screeningItemRules" inline>
    <el-form-item prop="product" label="产品">
      <el-select v-model="screeningItemForm.product" placeholder="产品名称" @change="getProjectList" size="medium">
        <el-option v-for="item in productList" :key="item.id" :label="item.productName" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="project" label="项目">
      <el-select v-model="screeningItemForm.project" placeholder="项目名称" size="medium">
        <el-option v-for="item in projectList" :key="item.id" :label="item.projectName" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
  </el-form>
  <!-- 组件引用 -->
  <!--
    例：titleLibrary.vue
    ————————template————————
    <screening-item ref="screeningRef" @screeningItemNum='getTitleList()'></screening-item>
    ————————事件中使用————————
    console.log(this.$refs.screeningRef.screeningItemForm)   需要在mounted中使用
  -->
</div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
// 表单验证
import { notNullableChange } from '@/components/form/formValidation'

export default {
  // 组件名称
  name: 'screeningItem',
  // 组件参数 接收来自父组件的数据
  props: {
  },
  // 组件状态值
  data() {
    return {
      screeningItemNum: 0,
      productList: [],
      projectList: [],
      screeningItemForm: {
        product: '',
        project: ''
      },
      screeningItemRules: {
        product: [notNullableChange('请选择产品名称')],
        project: [notNullableChange('请选择项目名称')]
      }
    }
  },
  mounted() {
    // console.log('screeningProductList', this.screeningProductList)
    // console.log('screeningProjectList', this.screeningProjectList)
    // console.log('screeningProduct', this.screeningProduct)
    // console.log('screeningProject', this.screeningProject)
    // console.log(this.screeningProductList.length > 0 && this.screeningProjectList.length > 0 && this.screeningProduct !== '' && this.screeningProduct !== undefined && this.screeningProject !== '' && this.screeningProject !== undefined)
    this.changeScreeningItem([this.screeningItemForm, this.productList, this.projectList])
    if (this.screeningProductList.length > 0 && this.screeningProjectList.length > 0 && this.screeningProduct !== '' && this.screeningProduct !== undefined && this.screeningProject !== '' && this.screeningProject !== undefined) {
      this.productList = this.screeningProductList
      this.projectList = this.screeningProjectList
      this.screeningItemForm = {
        product: this.screeningProduct,
        project: this.screeningProject
      }
    } else {
      this.getProductList()
    }
  },
  watch: {
    screeningProduct() {
      this.screeningItemForm.product = this.screeningProduct
    },
    screeningProject() {
      this.screeningItemForm.project = this.screeningProject
    },
    'screeningItemForm.project': {
      deep: true,
      handler: function(newV, oldV) {
        this.changeItem()
      }
    }
  },
  methods: {
    getProductList() {
      this.$service.post('/api/project/getProductList4Common').then(res => {
        if (res.result.length > 0) {
          this.productList = res.result
          if (localStorage.screeningProduct) {
            let result = res.result.some(item => {
              return item.id === parseInt(localStorage.screeningProduct)
            })
            console.log('screeningProduct', result)
            if (result) {
              this.screeningItemForm.product = parseInt(localStorage.screeningProduct)
            }
          }
          if (this.screeningItemForm.product !== '' && this.screeningItemForm.product !== undefined) {
          } else {
            this.screeningItemForm.product = res.result[0].id
          }
          this.getProjectList()
        } else {
          this.projectList = []
          this.screeningItemForm.product = ''
        }
      }).catch(Err => {
        console.log(Err)
      })
    },
    getProjectList() {
      console.log('getProjectList', this.screeningItemForm.product)
      if (this.screeningItemForm.product !== '' && this.screeningItemForm.product !== undefined) {
        this.$service.post('/api/project/getProjectList4Common', {
          productId: this.screeningItemForm.product
        }).then(res => {
          if (res.result.length > 0) {
            let ids = []
            // let selectId = this.screeningItemForm.project
            res.result.forEach(item => {
              ids.push(item.id)
            })
            this.projectList = res.result
            let flag = false
            if (localStorage.screeningProject) {
              let result = res.result.some(item => {
                return item.id === parseInt(localStorage.screeningProject)
              })
              console.log('screeningProject', localStorage.screeningProject)
              console.log('screeningProject', result)
              if (result) {
                this.screeningItemForm.project = parseInt(localStorage.screeningProject)
                flag = true
                // this.changeItem()
              }
            }
            if (!flag) {
              this.screeningItemForm.project = res.result[0].id
            }
          } else {
            this.projectList = []
            this.screeningItemForm.project = ''
          }
        }).catch(Err => {
          console.log(Err)
        })
      }
    },
    changeItem() {
      // console.log('changeItem', localStorage.screeningProduct, this.screeningItemForm.product, localStorage.screeningProject, this.screeningItemForm.project)
      this.changeScreeningItem([this.screeningItemForm, this.productList, this.projectList])
      if (parseInt(localStorage.screeningProduct) !== this.screeningItemForm.product || parseInt(localStorage.screeningProject) !== this.screeningItemForm.project) {
        // console.log(this.screeningItemForm, this.productList, this.projectList)
        this.$emit('screeningItemNum', this.screeningItemNum + 1)
        localStorage.screeningProduct = this.screeningItemForm.product
        localStorage.screeningProject = this.screeningItemForm.project
      }
    },
    ...mapMutations(['changeScreeningItem'])
  },
  computed: {
    ...mapState(['screeningProductList', 'screeningProjectList', 'screeningProduct', 'screeningProject'])
  }
}
</script>

<style lang="less" scoped>
@import './../../styles/common/public.less';
.screeningItem{
  position:absolute;
  top: 0.3rem;
  right: 0.45rem;
  z-index: 10;
  /deep/ .el-form-item {
    margin: 0 0 0 5px;
    border: 1px solid @borderColor;
    .borderRadius(3px);
    background: #fff;
    height: 38px;
    overflow: hidden;
    .el-form-item__label{
      line-height: 36px;
      padding: 0 0 0 10px;
      &::before{
        display: none;
      }
    }
    .el-form-item__content{
      line-height: 36px;
      .el-select{
        width: 150px;
        .el-input{
          height: 36px;
          .el-input__inner{
            border: 0;
            font-weight: bold;
            color: @fontColor;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/screeningItem.vue